import React, { Component } from 'react';
import Tooltip from 'rc-tooltip';

import { ShipstationIcon } from './ShipstationShopIcon.styles';

export default class ShipstationShopIcon extends Component {
  render() {
    return (
      <Tooltip
        placement="bottom"
        overlay={'This shop is integrated with Shipstation'}
        arrowContent={<div className="rc-tooltip-arrow-inner" />}
      >
        <ShipstationIcon className="tooltip-icon" src="/images/shipstation-icon.svg" alt="info-icon" />
      </Tooltip>
    );
  }
}
